export const BLOCKED_RETURN_REASON = {
	RETURNS_LIMIT: 'returnsLimit',
}
